import { StateUtils } from 'utils';

const ARTISTS = 'ArtistsDetails';
const tag = StateUtils.actionType(ARTISTS);

export const BEFORE_FETCH_ARTIST = tag`BEFORE_FETCH_ARTIST`;
export const ON_FETCH_ARTIST = tag`ON_FETCH_ARTIST`;
export const ON_ERROR_FETCH_ARTIST = tag`ON_ERROR_FETCH_ARTIST`;
export const ERROR_FETCH_ARTIST_DESC = 'Ocorreu um erro ao carregar a pagina.';
